
export type SolveConnectorPlacementModelMode = typeof SolveConnectorPlacementModelMode[keyof typeof SolveConnectorPlacementModelMode];


export const SolveConnectorPlacementModelMode = {
  Automatic: 'Automatic',
  Manual: 'Manual',
} as const;
